import { Card, CardBody, CardHeader } from '@components/card/card';
import { receiptTypeEnum } from '../receiptTypeEnum';
import { useEffect, useState } from 'react';
import { useAppDispatch } from '@store/hooks';
import { getArTransactionsById } from '@store/Finance/AR/ArTransactions/ArTransactionsSlice';
import { getArReceiptsById } from '@store/Finance/AR/ArReceipts/ArReceiptsSlice';

const ReceiptDetailsCard = ({ receiptType, Id }: any) => {

  // console.log(receiptType , Id);
  

  const dispatch = useAppDispatch();
  const [prePaymentData, setprePaymentData] = useState<any>(null);
  const [debitMemoData, setDebitMemoData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  // استدعاء البيانات بناءً على النوع والمعرف
  useEffect(() => {
    const fetchData = async () => {
      if (!Id) return;
      setLoading(true);
      setError(null);

      try {
        if (receiptType === receiptTypeEnum.ApplyDebitMemo || receiptType === receiptTypeEnum.Refund) {
          const res = await dispatch(getArTransactionsById(Id));

          if (getArTransactionsById.fulfilled.match(res)) {
            setDebitMemoData(res.payload);
          } else {
            setError('فشل في جلب بيانات إشعار المدين');
          }
        } else if (receiptType === receiptTypeEnum.ApplyPreReceipt) {
          const res = await dispatch(getArReceiptsById(Id));
          if (getArReceiptsById.fulfilled.match(res)) {
            setprePaymentData(res.payload);
          } else {
            setError('فشل في جلب بيانات الدفعة المقدمة');
          }
        }
      } catch (err: any) {
        setError(err.message || 'حدث خطأ أثناء جلب البيانات');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [receiptType, Id]);

  if (!Id) return null;

  if (loading) {
    return (
      <div className='col-12'>
        <Card className='border-warning'>
          <CardBody className='text-center'>
            <div className='spinner-border spinner-border-sm me-2'></div>
            جاري التحميل...
          </CardBody>
        </Card>
      </div>
    );
  }

  if (error) {
    return (
      <div className='col-12'>
        <Card className='border-danger'>
          <CardBody className='text-center text-danger'>
            <i className='fas fa-exclamation-triangle me-2'></i>
            خطأ في تحميل البيانات: {error}
          </CardBody>
        </Card>
      </div>
    );
  }

  // بيانات اشعار المدين
  if ((receiptType === receiptTypeEnum.ApplyDebitMemo || receiptType === receiptTypeEnum.Refund) && debitMemoData) {
    return (
      <div className='shadow-sm border border-warning mb-4 '>
        <div className='card-header bg-warning bg-opacity-25 d-flex justify-content-between align-items-center'>
          <h6 className='mb-0'>
            <i className='fas fa-rotate-left me-2'></i>
            فاتورة المردود المختارة
          </h6>
        </div>

        <div className='card-body p-0'>
          <div className='table-responsive'>
            <table className='table table-hover mb-0'>
              <thead className='table-actived fw-bold'>
                <tr>
                  <th className='text-center small'>رقم الفاتورة</th>
                  <th className='text-center small'>تاريخ الفاتورة</th>
                  <th className='text-center small'>المبلغ </th>
                  <th className='text-center small'>النوع</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className='text-center align-middle'>
                    <span className='fw-bold'>{debitMemoData.transactionNum}</span>
                  </td>
                  <td className='text-center align-middle'>{debitMemoData.transactionDate?.split('T')[0]}</td>
                  <td className='text-center align-middle'>
                    <span className='fw-bold text-success'>
                      {Number(debitMemoData.transactionAmount).toLocaleString()}
                    </span>
                  </td>
                  <td className='text-center align-middle'>
                    <span className='badge bg-warning'>إشعار مدين</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  if (receiptType === receiptTypeEnum.ApplyPreReceipt && prePaymentData) {
    return (
      <div className='col-12'>
        <Card className='border-info mb-4'>
          <div className='card-header d-flex justify-content-between align-items-center'>
            <h6 className='mb-0'>
              <i className='fas fa-money-bill-wave me-2'></i>
              الدفعة المقدمة المختارة
              <span className='badge bg-info ms-2'>دفعة مقدمة</span>
            </h6>
          </div>

          <div className='card-body p-0'>
            <div className='table-responsive'>
              <table className='table table-hover mb-0'>
                <thead className='table-actived fw-bold'>
                  <tr>
                    <th className='text-center small'>رقم سند الدفع</th>
                    <th className='text-center small'>التاريخ</th>
                    <th className='text-center small'>المبلغ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className='text-center align-middle'>
                      <span className='fw-bold'>{prePaymentData.code}</span>
                    </td>
                    <td className='text-center align-middle'>{prePaymentData.depositDate?.split('T')[0]}</td>
                    <td className='text-center align-middle'>
                      <span className='fw-bold text-primary'>{Number(prePaymentData.amount).toLocaleString()}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Card>
      </div>
    );
  }

  return null;
};

export default ReceiptDetailsCard;






// import { Card, CardBody, CardHeader } from '@components/card/card';
// import { receiptTypeEnum } from '../receiptTypeEnum';
// import { useEffect, useState } from 'react';
// import { useAppDispatch } from '@store/hooks';
// import { getArTransactionsById } from '@store/Finance/AR/ArTransactions/ArTransactionsSlice';
// import { getArReceiptsById } from '@store/Finance/AR/ArReceipts/ArReceiptsSlice';

// const ReceiptDetailsCard = ({ receiptType, Id, scheduleCount }: any) => {
//   const dispatch = useAppDispatch();
//   const [preReceiptData, setPreReceiptData] = useState<any>(null);
//   const [debitMemoData, setDebitMemoData] = useState<any>(null);
//   const [loading, setLoading] = useState<boolean>(false);
//   const [error, setError] = useState<string | null>(null);

//   // استدعاء البيانات بناءً على النوع والمعرف
//   useEffect(() => {
//     const fetchData = async () => {
//       if (!Id) return;
//       setLoading(true);
//       setError(null);

//       try {
//         if (receiptType === receiptTypeEnum.ApplyDebitMemo || receiptType === receiptTypeEnum.Refund) {
//           const res = await dispatch(getArTransactionsById(Id));
//           if (getArTransactionsById.fulfilled.match(res)) {
//             setDebitMemoData(res.payload);
//           } else {
//             setError('فشل في جلب بيانات إشعار المدين');
//           }
//         } else if (receiptType === receiptTypeEnum.ApplyPreReceipt) {
//           const res = await dispatch(getArReceiptsById(Id));
//           if (getArReceiptsById.fulfilled.match(res)) {
//             setPreReceiptData(res.payload);
//           } else {
//             setError('فشل في جلب بيانات المقبوضات المقدمة');
//           }
//         }
//       } catch (err: any) {
//         setError(err.message || 'حدث خطأ أثناء جلب البيانات');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [receiptType, Id, dispatch]);

//   if (!Id) return null;

//   if (loading) {
//     return (
//       <div className='col-12'>
//         <Card className='border-warning mb-4'>
//           <CardBody className='text-center py-4'>
//             <div className='spinner-border spinner-border-sm text-warning me-2'></div>
//             <span className='text-muted'>جاري تحميل البيانات...</span>
//           </CardBody>
//         </Card>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className='col-12'>
//         <Card className='border-danger mb-4'>
//           <CardBody className='text-center text-danger py-3'>
//             <i className='fas fa-exclamation-triangle me-2'></i>
//             <span>خطأ في تحميل البيانات: {error}</span>
//           </CardBody>
//         </Card>
//       </div>
//     );
//   }

//   // بيانات إشعار المدين
//   if ((receiptType === receiptTypeEnum.ApplyDebitMemo || receiptType === receiptTypeEnum.Refund) && debitMemoData) {
//     return (
//       <div className='col-12'>
//         <Card className='border-warning mb-4'>
//           <CardHeader className='bg-warning bg-opacity-10 d-flex justify-content-between align-items-center py-3'>
//             <h6 className='mb-0 text-warning'>
//               <i className='fas fa-file-invoice-dollar me-2'></i>
//               فاتورة المردود المختارة
//               <span className='badge bg-warning text-dark ms-2'>إشعار مدين</span>
//             </h6>
//             <div className='d-flex align-items-center'>
//               <span className='badge bg-light text-dark me-2'>
//                 <i className='fas fa-hashtag me-1'></i>
//                 {debitMemoData.transactionNum}
//               </span>
//             </div>
//           </CardHeader>
//           <CardBody className='p-0'>
//             <div className='table-responsive'>
//               <table className='table table-hover mb-0'>
//                 <thead className='bg-light'>
//                   <tr>
//                     <th className='text-center small fw-bold text-muted'>رقم الفاتورة</th>
//                     <th className='text-center small fw-bold text-muted'>تاريخ الفاتورة</th>
//                     <th className='text-center small fw-bold text-muted'>المبلغ</th>
//                     <th className='text-center small fw-bold text-muted'>الحالة</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr>
//                     <td className='text-center align-middle'>
//                       <span className='fw-bold text-dark'>{debitMemoData.transactionNum}</span>
//                     </td>
//                     <td className='text-center align-middle'>
//                       <span className='text-muted'>{debitMemoData.transactionDate?.split('T')[0]}</span>
//                     </td>
//                     <td className='text-center align-middle'>
//                       <span className='fw-bold fs-6 text-success'>
//                         {Number(debitMemoData.transactionAmount).toLocaleString()} <small></small>
//                       </span>
//                     </td>
//                     <td className='text-center align-middle'>
//                       <span className='badge bg-warning bg-opacity-20 text-warning border border-warning'>
//                         <i className='fas fa-receipt me-1'></i>
//                         إشعار مدين
//                       </span>
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </CardBody>
//         </Card>
//       </div>
//     );
//   }

//   // بيانات المقبوضات المقدمة
//   if (receiptType === receiptTypeEnum.ApplyPreReceipt && preReceiptData) {
//     return (
//       <div className='col-12'>
//         <Card className='border-info mb-4'>
//           <CardHeader className='bg-info bg-opacity-10 d-flex justify-content-between align-items-center py-3'>
//             <h6 className='mb-0 text-info'>
//               <i className='fas fa-hand-holding-usd me-2'></i>
//               المقبوضات المقدمة المختارة
//               <span className='badge bg-info ms-2'>مقبوضات مقدمة</span>
//             </h6>
//             <div className='d-flex align-items-center'>
//               <span className='badge bg-light text-dark me-2'>
//                 <i className='fas fa-hashtag me-1'></i>
//                 {preReceiptData.code}
//               </span>
//               {scheduleCount > 0 && (
//                 <span className='badge bg-success'>
//                   <i className='fas fa-list me-1'></i>
//                   {scheduleCount} فاتورة
//                 </span>
//               )}
//             </div>
//           </CardHeader>
//           <CardBody className='p-0'>
//             <div className='table-responsive'>
//               <table className='table table-hover mb-0'>
//                 <thead className='bg-light'>
//                   <tr>
//                     <th className='text-center small fw-bold text-muted'>رقم سند القبض</th>
//                     <th className='text-center small fw-bold text-muted'>التاريخ</th>
//                     <th className='text-center small fw-bold text-muted'>المبلغ</th>
//                     <th className='text-center small fw-bold text-muted'>النوع</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr>
//                     <td className='text-center align-middle'>
//                       <span className='fw-bold text-dark'>{preReceiptData.code}</span>
//                     </td>
//                     <td className='text-center align-middle'>
//                       <span className='text-muted'>{preReceiptData.depositDate?.split('T')[0]}</span>
//                     </td>
//                     <td className='text-center align-middle'>
//                       <span className='fw-bold fs-6 text-primary'>
//                         {Number(preReceiptData.amount).toLocaleString()} <small>ر.س</small>
//                       </span>
//                     </td>
//                     <td className='text-center align-middle'>
//                       <span className='badge bg-info bg-opacity-20 text-info border border-info'>
//                         <i className='fas fa-money-bill-wave me-1'></i>
//                         مقبوضات مقدمة
//                       </span>
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </CardBody>
//         </Card>
//       </div>
//     );
//   }

//   return null;
// };

// export default ReceiptDetailsCard;